import React, { PropsWithChildren } from "react";

const NoLayout: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default NoLayout;
